export default {
  page: {
    title: 'Eliminador de caracteres especiales',
    subtitle: 'Herramientas',
  },
  card: {
    title: 'Eliminador de caracteres especiales',
  },
  form: {
    text: {
      label: 'Texto original',
      placeholder: 'Pegue su texto aquí...',
    },
    keepPunctuation: {
      label: 'Mantener puntuación',
    },
    keepLineBreaks: {
      label: 'Mantener saltos de línea',
    },
    result: {
      label: 'Texto limpio',
    },
  },
  alert: {
    textCopied: '¡Texto copiado!',
  },
};
